import { FormController } from '../classes/form-controller';
const axios = require('axios');

export default class extends FormController {
	static targets = [
		'container',
		'form',
		'field',
		'input',
		'errorNotice',
		'successNotice',

		'step1',
		'step2',
		'step3',
		'step3_1',
		'step3_2',
		'step4',
		'step4message',
		'step5',

		'step1SubmitButton',
		'step2SubmitButton',
		'step3SubmitButton',
		'step3_1SubmitButton',
		'step3_2SubmitButton',
		'step4SubmitButton',
	];

	connect() {
		// Call connect from FormController
		super.connect();
	}

	/**
	 * Submit step 1 - Accept terms.
	 *
	 * @param {Event} e
	 */
	submitStep1(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'internal_vacancy_application_form_submit_step_1');

		this.step1Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step1Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					this.step1Target.classList.add('hidden');
					this.step2Target.classList.remove('hidden');

					this.containerTarget.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});

					this.setBeforeUnloadAlert();

					this.step1SubmitButtonTarget.setAttribute('type', 'button');
					this.step2SubmitButtonTarget.setAttribute('type', 'submit');
				}
			})
			.catch((error) => {
				console.log(error);
				this.step1Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 2 - Enter email.
	 *
	 * @param {Event} e
	 */
	submitStep2(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'internal_vacancy_application_form_submit_step_2');

		this.step2Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step2Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					this.step2Target.classList.add('hidden');

					// If user exists show password step
					if (response.data.userExists == true) {
						this.step3Target.classList.remove('hidden');

						// If user does not exist skip this step
					} else {
						this.step4Target.classList.remove('hidden');
					}

					this.containerTarget.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});

					this.step2SubmitButtonTarget.setAttribute('type', 'button');
					this.step3SubmitButtonTarget.setAttribute('type', 'submit');
				}
			})
			.catch((error) => {
				console.log(error);
				this.step2Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 3 - Enter password.
	 *
	 * @param {Event} e
	 */
	submitStep3(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'internal_vacancy_application_form_submit_step_3');

		this.step3Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step3Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					this.step3Target.classList.add('hidden');
					this.step4Target.classList.remove('hidden');

					this.containerTarget.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});

					this.step3SubmitButtonTarget.setAttribute('type', 'button');
					this.step4SubmitButtonTarget.setAttribute('type', 'submit');
				}
			})
			.catch((error) => {
				console.log(error);
				this.step3Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 3.1 - Request password reset.
	 *
	 * @param {Event} e
	 */
	submitStep3_1(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'internal_vacancy_application_form_submit_step_3_1');

		this.step3_1SubmitButtonTarget.classList.add('btn-loading');
		this.step3_1Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step3_1Target.removeAttribute('data-group-loading');
					this.step3_1SubmitButtonTarget.classList.remove('btn-loading');
				}

				if (response.data.status == 'success') {
					this.step3Target.classList.add('hidden');
					this.step3_2Target.classList.remove('hidden');

					this.containerTarget.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});

					this.step3SubmitButtonTarget.setAttribute('type', 'button');
					this.step3_2SubmitButtonTarget.setAttribute('type', 'submit');
				}
			})
			.catch((error) => {
				console.log(error);
				this.step3_1Target.removeAttribute('data-group-loading');
				this.step3_1SubmitButtonTarget.classList.remove('btn-loading');
			});
	}

	/**
	 * Submit step 3.2 - Reset password.
	 *
	 * @param {Event} e
	 */
	submitStep3_2(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'internal_vacancy_application_form_submit_step_3_2');

		this.step3_2Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData)
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step3_2Target.removeAttribute('data-group-loading');
				}

				if (response.data.status == 'success') {
					this.step3_2Target.classList.add('hidden');
					this.step4Target.classList.remove('hidden');

					this.containerTarget.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});

					this.step3_2SubmitButtonTarget.setAttribute('type', 'button');
					this.step4SubmitButtonTarget.setAttribute('type', 'submit');
				}

				if (response.data.notice) {
					this.successNoticeTarget.innerHTML = response.data.notice;
				}
			})
			.catch((error) => {
				console.log(error);
				this.step3_2Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Submit step 4 - Profile.
	 *
	 * @param {Event} e
	 */
	submitStep4(e) {
		e.preventDefault();

		const formData = new FormData(this.formTarget);
		formData.append('action', 'internal_vacancy_application_form_submit_step_4');

		this.step4Target.setAttribute('data-group-loading', 'true');

		axios
			.post(supersage.ajaxURL, formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			.then((response) => {
				if (response.data.status == 'error') {
					this.displayErrors(response.data.errors);
					this.step4Target.removeAttribute('data-group-loading');

					// Scroll error in view
					const firstErrorField = this.containerTarget.querySelector('[data-group-error="true"]');

					if (this.errorNoticeTarget.hasChildNodes()) {
						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					} else if (firstErrorField) {
						firstErrorField.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					} else {
						this.containerTarget.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
						});
					}
				}

				if (response.data.status == 'success') {
					// Hide error notice from step 4.
					this.errorNoticeTarget.innerHTML = '';

					this.step4Target.classList.add('hidden');
					this.step5Target.classList.remove('hidden');

					this.containerTarget.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
					});

					this.step4SubmitButtonTarget.setAttribute('type', 'button');

					this.removeBeforeUnloadAlert();
				}
			})
			.catch((error) => {
				console.log(error);
				this.step4messageTarget.classList.remove('hidden');
				this.step4messageTarget.classList.add('block');
				this.step4Target.removeAttribute('data-group-loading');
			});
	}

	/**
	 * Set before unload alert.
	 */
	setBeforeUnloadAlert() {
		window.onbeforeunload = function () {
			return 'Het formulier is nog niet verzonden. Weet je zeker dat je de pagina wilt verlaten?';
		};
	}

	/**
	 * Remove before unload alert.
	 */
	removeBeforeUnloadAlert() {
		window.onbeforeunload = null;
	}
}
